import { render, staticRenderFns } from "./ProductMobile.vue?vue&type=template&id=c61c3350&scoped=true&"
import script from "./ProductMobile.vue?vue&type=script&lang=js&"
export * from "./ProductMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductMobile.vue?vue&type=style&index=0&id=c61c3350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61c3350",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VCardText,VCarousel,VCarouselItem,VContainer,VDivider,VSkeletonLoader})
